
(()=>{
    function handlePdpWishlistButton(){
        
        const wishlistAppBlock = window.document.querySelector('[id^="shopify-block-wishlist_hero_custom_product_button_"]');
        if (!wishlistAppBlock){
            const productContentContainer = window.document.querySelector('.product__content');
            if (!productContentContainer) return;
            const observer = new MutationObserver((mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach(node => {
                            if (node.nodeType === 1 && node.id.startsWith('shopify-block-wishlist_hero_custom_product_button_')) {
                                moveWishlistButton(node);
                                observer.disconnect();
                            }
                        });
                    }
                }
            });
            const config = { childList: true, subtree: true };
            observer.observe(productContentContainer, config);
        }
        else moveWishlistButton(wishlistAppBlock);
    }
    function moveWishlistButton(wishlistBtnContainer){
        const titleContainer = window.document.querySelector('.product__title__wrapper');
        if (!titleContainer) return;
        titleContainer.appendChild(wishlistBtnContainer);
    }

window.addEventListener('DOMContentLoaded',handlePdpWishlistButton);
})();